import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { OrderBumpModal } from './OrderBumpModal';
export function FinalCTASection() {
  const [selectedPack, setSelectedPack] = useState<'basic' | 'pro'>('pro');
  const [isModalOpen, setIsModalOpen] = useState(false);
  return <section className="w-full py-20 px-4 sm:px-6 lg:px-8 flex flex-col items-center" data-id="element-75">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="w-full max-w-3xl flex flex-col items-center" data-id="element-76">
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-white text-center mb-10 uppercase italic" data-id="element-77">
          ELEGÍ TU <span className="text-brand-gold" data-id="element-78">MEGAPACK</span>
        </h2>

        <div className="w-full flex flex-col gap-4 mb-8" data-id="element-79">
          <div onClick={() => setSelectedPack('basic')} className={`w-full rounded-xl p-5 sm:p-6 cursor-pointer transition-all duration-200 flex items-start gap-4 ${selectedPack === 'basic' ? 'bg-[#111] border-2 border-brand-gold shadow-[0_0_20px_rgba(201,168,76,0.15)]' : 'bg-[#0d0d0d] border border-gray-700 hover:border-gray-500'}`} data-id="element-80">
            <div className="shrink-0 mt-1" data-id="element-81">
              <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${selectedPack === 'basic' ? 'border-brand-gold' : 'border-gray-600'}`} data-id="element-82">
                {selectedPack === 'basic' && <div className="w-2.5 h-2.5 rounded-full bg-brand-gold" data-id="element-83" />}
              </div>
            </div>
            <div className="flex-grow flex flex-col sm:flex-row sm:items-start justify-between gap-3" data-id="element-84">
              <div className="flex flex-col" data-id="element-85">
                <h3 className="text-base sm:text-lg font-bold text-white mb-0.5 flex items-center gap-2" data-id="element-86">
                  <span data-id="element-87">📘</span> MEGAPACK SALIR DEL VERAZ
                </h3>
                <p className="text-gray-400 text-sm" data-id="element-88">6 Tomos + 6 Bonos</p>
                <p className="text-brand-gold text-xs font-medium mt-1" data-id="element-89">
                  Ideal para: Todos los casos de Veraz y BCRA
                </p>
              </div>
              <div className="flex flex-col items-start sm:items-end shrink-0" data-id="element-90">
                <span className="text-gray-500 line-through text-xs" data-id="element-91">
                  $39.998
                </span>
                <span className="text-2xl sm:text-3xl font-extrabold text-white leading-tight" data-id="element-92">
                  $19.999 ARS
                </span>
              </div>
            </div>
          </div>

          <div onClick={() => setSelectedPack('pro')} className={`w-full rounded-xl p-5 sm:p-6 cursor-pointer transition-all duration-200 flex items-start gap-4 ${selectedPack === 'pro' ? 'bg-[#111] border-2 border-brand-gold shadow-[0_0_20px_rgba(201,168,76,0.15)]' : 'bg-[#0d0d0d] border border-gray-700 hover:border-gray-500'}`} data-id="element-93">
            <div className="shrink-0 mt-1" data-id="element-94">
              <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${selectedPack === 'pro' ? 'border-brand-gold' : 'border-gray-600'}`} data-id="element-95">
                {selectedPack === 'pro' && <div className="w-2.5 h-2.5 rounded-full bg-brand-gold" data-id="element-96" />}
              </div>
            </div>
            <div className="flex-grow flex flex-col sm:flex-row sm:items-start justify-between gap-3" data-id="element-97">
              <div className="flex flex-col" data-id="element-98">
                <div className="text-2xl mb-1" data-id="element-99">🏆</div>
                <h3 className="text-base sm:text-lg font-bold text-white mb-0.5" data-id="element-100">
                  MEGAPACK + RETRIBUCIÓN
                </h3>
                <div className="text-brand-gold text-lg mb-1" data-id="element-101">⭐</div>
                <p className="text-gray-400 text-sm" data-id="element-102">
                  6 Tomos + 6 Bonos + Kit Retribución completo
                </p>
                <p className="text-brand-gold text-xs font-medium mt-1" data-id="element-103">
                  Ideal para: Quienes quieren reclamar daños y perjuicios
                </p>
              </div>
              <div className="flex flex-col items-start sm:items-end shrink-0" data-id="element-104">
                <span className="text-gray-500 line-through text-xs" data-id="element-105">
                  $54.998
                </span>
                <span className="text-2xl sm:text-3xl font-extrabold text-brand-gold leading-tight" data-id="element-106">
                  $27.999 ARS
                </span>
              </div>
            </div>
          </div>
        </div>

        <button onClick={() => setIsModalOpen(true)} className="w-full bg-green-500 hover:bg-green-600 text-black font-bold text-lg sm:text-xl py-5 px-8 rounded-xl transition-all transform hover:scale-105 shadow-[0_0_25px_rgba(34,197,94,0.3)] block text-center" data-id="element-107">
          {selectedPack === 'basic' ? '→ QUIERO MI MEGAPACK' : '→ QUIERO EL MEGAPACK + RETRIBUCIÓN'}
        </button>
      </motion.div>

      <OrderBumpModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} selectedPack={selectedPack} data-id="element-108" />
    </section>;
}